import { Component, OnInit,ChangeDetectionStrategy,
    ViewEncapsulation, Input, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store'; 
import { Observable, Subscription } from 'rxjs';
import { AppConfig, NavMenuColor } from '@app/shared/types/app-config.interface';
import { UpdateMobileNavCollapse } from '@app/store/app-config/app-config.action';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'mobile-nav',
    templateUrl: 'mobile-nav.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.mobile-nav]': 'true',
        '[class.is-open]': 'isOpen',
        '[class.nav-menu-light]': "color === 'light'",
        '[class.nav-menu-dark]': "color === 'dark'"
    },
    animations: [
        trigger('slideInOut', [
            state(
                'visible',
                style({
                    height: '*',
                    opacity: 1,
                })
            ),
            state(
                'hidden',
                style({
                    height: '0',
                    opacity: 0,
                })
            ),
            transition('visible <=> hidden', animate('300ms ease-in-out')),
        ]),
    ],
})

export class MobileNavComponent implements OnInit {
    @Select((state: { app: AppConfig; }) => state.app) app$: Observable<AppConfig>;
    @Input() isOpen: boolean
    @Input() color: NavMenuColor = 'light';
    subscription: Subscription
    isSubMenuOpen: boolean;

    constructor(private cdr: ChangeDetectorRef, private store: Store) { }

    ngOnInit() {
        this.subscription = this.app$.subscribe(app => {
            this.isOpen = app.mobileNavCollapse
            this.cdr.markForCheck()
        });
    }

    closeNav() {
        this.isOpen = false;
        this.store.dispatch(new UpdateMobileNavCollapse(this.isOpen));
    }

    onClicked() {
        this.closeNav()
    }
    // toggleSubMenu() {
    //     this.isSubMenuOpen = !this.isSubMenuOpen;
    //   }
    submenus: { [key: string]: boolean } = {
        user: false,
        admin: false,
    };
  
    toggleSubMenu(submenu: string, event: Event) {
        this.submenus = {
            ...this.submenus,
            [submenu]: !this.submenus[submenu],
        };
  
        // Close other submenus
        Object.keys(this.submenus).forEach((key) => {
            if (key !== submenu) {
                this.submenus[key] = false;
            }
        });
  
        // Prevent the default action of the event
        event.preventDefault();
    }
}